import Conversations from "@/views/conversations/Conversations.vue";
import ConversationDetails from "@/views/conversations/ConversationDetails/ConversationDetails.vue";
import NewConversation from "@/views/conversations/NewConversation.vue";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import { redirectWithPermissionCheck } from "@/router/index";

const { CONVERSATIONS } = MAIN_NAVIGATION_ITEMS;

export const conversationsRoutes = [
  {
    path: "/conversations",
    name: CONVERSATIONS,
    component: Conversations,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "conversations.view");
    }
  },
  {
    path: "/conversations/:conversationId",
    name: "conversationDetails",
    component: ConversationDetails,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "conversations.view");
    }
  },
  {
    path: "/new-conversation",
    name: "newConversation",
    component: NewConversation,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "conversations.create");
    }
  }
];
